
function initFamilyBuilder(config){
  'use strict';
  var root=document.getElementById(config.v0);
  if(!root||root.dataset.pfpReady==='1')return;
  root.dataset.pfpReady='1';

  var variants=config.v1;
  var messages={loading:config.v2,ready:config.v3,failed:config.v4,soldout:config.v5,saving:config.v6};
  var atlasUrls=config.artUrls;


  var state={
    count:1,
    mat:'Beige',
    family:'Familie Wagner',
    members:Array.from({length:7},function(_,i){return {
      type:['man','woman','boy','girl','cat','dog','man'][i],
      name:['Kim','Anna','Max','Lina','Mia','Buddy','Tom'][i],
      skin:1,eyes:1,hairStyle:0,hairColor:2,beard:i===0?3:0,glasses:0,clothes:i%8,
      animalBreed:0,animalColor:0,animalEyes:2,open:i===0
    };})
  };

  var typeNames={man:'Mann',woman:'Frau',boy:'Junge',girl:'Mädchen',cat:'Katze',dog:'Hund'};
  var typeKeys=Object.keys(typeNames);
  var skinNames=['Sehr hell','Hell','Mittel','Warm','Dunkel','Sehr dunkel'];
  var skinColors=['#f7d7bd','#efc09c','#dba27c','#bd805d','#91583d','#643a2b'];
  var eyeNames=['Blau','Grün','Braun','Schwarz','Grau','Hazel'];
  var eyeColors=['#4d83b7','#548451','#63412d','#242424','#8b939a','#8d7954'];
  var hairColors=['Schwarz','Dunkelbraun','Braun','Hellbraun','Blond','Rot','Grau','Weiß'];
  var maleHair=['Kurz','Kurz modern','Undercut','Seitenscheitel','Lockig','Wellig','Lang','Glatze','Zopf'];
  var femaleHair=['Kurz','Bob','Schulterlang','Lang','Sehr lang','Lockig','Wellig','Zopf'];
  var boyHair=['Kurz','Kurz modern','Undercut','Seitenscheitel','Lockig','Wellig','Schulterlang','Pony'];
  var girlHair=['Kurz','Bob','Schulterlang','Lang','Lockig','Wellig','Zöpfe','Pony'];
  function hairstyles(m){return m.type==='man'?maleHair:m.type==='woman'?femaleHair:m.type==='boy'?boyHair:girlHair;}
  var beardNames=['Ohne Bart','Kurzer Bart','Stoppelbart','Vollbart','Dichter Bart','Kinnbart','Schnurrbart','Vollbart lang'];
  var glassesNames=['Keine Brille','Schwarz','Braun','Rund','Metall','Modern','Groß','Fein'];
  var clothesNames=['Grau','Creme','Braun','Blau','Grün','Rot','Schwarz','Rosa'];
  var clothesColors=['#9aa0a8','#d8c7a9','#8b6248','#55789c','#5c805d','#b64b45','#33363b','#d58da9'];
  var dogNames=['Französische Bulldogge','Golden Retriever','Labrador','Beagle','Corgi','Dackel','Pudel','Chihuahua','Border Collie','Deutscher Schäferhund','Boxer','Rottweiler','Yorkshire Terrier','Cocker Spaniel','Bernhardiner','Havanese','Zwergspitz (Pomeranian)'];
  var catNames=['Neva Masquerade','Ragdoll','British Kurzhaar','Maine Coon','Siamkatze','Bengalkatze','Türkisch Angora','Norwegische Waldkatze','Perserkatze','Hauskatze','Schwarze Katze','Graue Katze','Sibirische Katze'];
  var dogVariants=[
    [['Gestromt',0],['Falb',1]],[['Gold',2],['Hellgold',3]],[['Gelb',4],['Schwarz',5],['Schokoladenbraun',6]],
    [['Dreifarbig',7],['Zitrone-Weiß',8]],[['Rot-Weiß',9],['Dreifarbig',10]],[['Schwarz-Loh',11],['Rot',12]],
    [['Apricot',13],['Weiß',14],['Schwarz',15]],[['Creme',16],['Schwarz-Loh',17]],[['Schwarz-Weiß',18],['Braun-Weiß',19]],
    [['Schwarz-Loh',20],['Schwarz',21]],[['Falb-Weiß',22],['Gestromt-Weiß',23]],[['Schwarz-Loh',24]],
    [['Stahlblau-Loh',25]],[['Gold',26],['Schwarz',27],['Braun',28]],[['Braun-Weiß',29]],[['Weiß',30],['Braun-Weiß',31]],
    [["Weiß", 32], ["Schwarz", 33], ["Braun", 34], ["Orange", 35], ["Graugewolkt", 36], ["Orange-Sable", 37], ["Creme", 38], ["Creme-Sable", 39], ["Black-and-Tan", 40], ["Black-and-Silver", 41], ["Brown-and-Tan", 42], ["Schwarz-Weiß", 43], ["Braun-Weiß", 44], ["Orange-Weiß", 45], ["Grau-Weiß", 46], ["Creme-Weiß", 47]]
  ];
  var catVariants=[
    [['Seal Point',0],['Blue Point',1],['Seal Tabby Point',2]],[['Seal Bicolor',3],['Blue Bicolor',4],['Seal Mitted',5]],
    [['Blaugrau',6],['Creme',7],['Schwarz',8]],[['Braun Tabby',9],['Black Smoke',10],['Rot Tabby',11]],
    [['Seal Point',12],['Blue Point',13]],[['Braun Rosetten',14],['Silber Rosetten',15],['Snow Lynx',16],['Charcoal',17]],
    [['Weiß',18],['Schwarz',19]],[['Braun Tabby-Weiß',20],['Schwarz-Weiß',21]],[['Weiß',22],['Silber Shaded',23]],
    [['Braun Tabby',24],['Rot-Weiß',25]],[['Schwarz',26]],[['Grau',27]],
    [['Braun Tabby',28],['Silber Tabby',29],['Rot Tabby',30],['Schwarz-Weiß',31]]
  ];
  function petVariants(m){return (m.type==='dog'?dogVariants:catVariants)[m.animalBreed]||[];}
  function petVariant(m){var choices=petVariants(m);return choices[Math.min(m.animalColor,choices.length-1)]||choices[0];}
  function petDescription(m){return (m.type==='dog'?dogNames:catNames)[m.animalBreed]+' · '+petVariant(m)[0];}

  var $=function(sel){return root.querySelector(sel);};
  var esc=function(value){return String(value==null?'':value).replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];});};
  var isHuman=function(type){return ['man','woman','boy','girl'].indexOf(type)>=0;};
  var isPet=function(type){return type==='dog'||type==='cat';};
  var typeRow=function(type){return Math.max(0,typeKeys.slice(0,4).indexOf(type));};
  var choiceGrid=function(items,current,key,palette){
    return '<div class="pfp-choice-grid" data-grid="'+key+'">'+items.map(function(label,i){
      var picture=['hairStyle','beard','glasses'].indexOf(key)>=0?'<canvas width="128" height="160" data-art-choice="'+key+'" data-art-value="'+i+'" aria-hidden="true"></canvas>':'';
      var dot=palette?'<span class="pfp-choice-dot" style="background:'+palette[i]+'"></span>':'';
      return '<button type="button" class="pfp-choice '+(Number(current)===i?'active':'')+'" data-choice="'+key+'" data-value="'+i+'">'+picture+dot+'<span>'+esc(label)+'</span></button>';
    }).join('')+'</div>';
  };

  function renderDetails(m){
    var html='<div class="pfp-option-title">Person oder Haustier</div>'+choiceGrid(typeKeys.map(function(k){return typeNames[k];}),typeKeys.indexOf(m.type),'type');
    if(isHuman(m.type)){
      var row=typeRow(m.type);
      var hair=hairstyles(m);
      html+='<div class="pfp-option-title">Hautfarbe</div>'+choiceGrid(skinNames,m.skin,'skin',skinColors);
      html+='<div class="pfp-option-title">Augenfarbe</div>'+choiceGrid(eyeNames,m.eyes,'eyes',eyeColors);
      html+='<div class="pfp-option-title">Frisur</div>'+choiceGrid(hair,m.hairStyle,'hairStyle');
      html+='<div class="pfp-option-title">Haarfarbe</div>'+choiceGrid(hairColors,m.hairColor,'hairColor',hairColors.map(function(_,i){return ['#24211f','#4b2f23','#75452b','#ae7847','#e9ca78','#b34b38','#a2a2a2','#e8e0cf'][i];}));
      if(m.type==='man')html+='<div class="pfp-option-title">Bart</div>'+choiceGrid(beardNames,m.beard,'beard');
      html+='<div class="pfp-option-title">Brille</div>'+choiceGrid(glassesNames,m.glasses,'glasses');
      html+='<div class="pfp-option-title">Kleidung</div>'+choiceGrid(clothesNames,m.clothes,'clothes',clothesColors);
    }else{
      var breedList=m.type==='dog'?dogNames:catNames;
      html+='<div class="pfp-option-title">'+(m.type==='dog'?'Hunderasse':'Katzenrasse')+'</div>'+choiceGrid(breedList,m.animalBreed,'animalBreed');
      html+='<div class="pfp-option-title">'+esc(config.v21)+'</div><div class="pfp-pet-variants">'+petVariants(m).map(function(v,i){return '<button type="button" class="pfp-choice pfp-pet-choice '+(m.animalColor===i?'active':'')+'" data-choice="animalColor" data-value="'+i+'"><canvas width="256" height="320" data-pet-variant="'+i+'" aria-hidden="true"></canvas><span>'+esc(v[0])+'</span></button>';}).join('')+'</div>';

    }
    return html;
  }

  function renderMembers(updatedIndex){
    var holder=$('[data-members]');
    while(holder.children.length>state.count)holder.lastElementChild.remove();
    for(var i=0;i<state.count;i++){
      var m=state.members[i];
      var card=holder.children[i];
      if(card&&updatedIndex!==i){
        if(isPet(m.type)&&artReady)card.querySelectorAll('[data-pet-variant]').forEach(function(c){var variantMember=Object.assign({},m,{animalColor:Number(c.dataset.petVariant)});c.getContext('2d').drawImage(drawMember(variantMember),0,0,c.width,c.height);});
        continue;
      }
      var existing=!!card;
      if(!card)card=document.createElement('div');
      card.className='pfp-member'+(m.open?' open':'');
      card.dataset.index=String(i);
      var icon={man:'👨🏻',woman:'👩🏻',boy:'👦🏻',girl:'👧🏻',dog:'🐶',cat:'🐱'}[m.type]||'👤';
      if(!existing){
        card.innerHTML='<div class="pfp-member-head"><div class="pfp-mini-avatar">'+icon+'</div><div><div class="pfp-member-kicker">Familienmitglied '+(i+1)+' · '+esc(typeNames[m.type])+'</div><input class="pfp-member-name" type="text" maxlength="24" value="'+esc(m.name)+'" aria-label="Name des Familienmitglieds '+(i+1)+'"></div><button class="pfp-member-toggle" type="button" aria-expanded="'+(m.open?'true':'false')+'" aria-label="Optionen öffnen">⌄</button></div><div class="pfp-member-details">'+renderDetails(m)+'</div>';
        holder.appendChild(card);
      }else{
        card.querySelector('.pfp-mini-avatar').textContent=icon;
        card.querySelector('.pfp-member-kicker').textContent='Familienmitglied '+(i+1)+' · '+typeNames[m.type];
        card.querySelector('.pfp-member-toggle').setAttribute('aria-expanded',String(m.open));
        var details=card.querySelector('.pfp-member-details'),next=document.createElement('div');
        next.innerHTML=renderDetails(m);
        var active=document.activeElement,focused=details.contains(active)?{key:active.dataset.choice,value:active.dataset.value}:null;
        var typeGrid=details.querySelector('[data-grid="type"]');
        next.querySelector('[data-grid="type"]').remove();next.firstElementChild.remove();
        typeGrid.querySelectorAll('[data-choice]').forEach(function(btn){btn.classList.toggle('active',Number(btn.dataset.value)===typeKeys.indexOf(m.type));});
        while(typeGrid.nextSibling)typeGrid.nextSibling.remove();
        details.append.apply(details,Array.from(next.childNodes));
        if(focused){
          var replacement=details.querySelector('[data-choice="'+focused.key+'"][data-value="'+focused.value+'"]');
          if(replacement)replacement.focus({preventScroll:true});
        }
      }
      if(isPet(m.type)&&artReady)card.querySelectorAll('[data-pet-variant]').forEach(function(c){var variantMember=Object.assign({},m,{animalColor:Number(c.dataset.petVariant)});c.getContext('2d').drawImage(drawMember(variantMember),0,0,c.width,c.height);});
    }
  }

  var atlasImages={},artReady=false,artRenderer=null;
  function drawMember(m){
    if(!artReady){var c=document.createElement('canvas');c.width=512;c.height=640;c.pfpTop=0;c.pfpBounds=[0,0,255,319];return c;}
    return artRenderer.draw(m,isPet(m.type)?petVariant(m)[1]:null);
  }
  function updateThumbnails(){
    root.querySelectorAll('.pfp-member').forEach(function(card){
      var m=state.members[Number(card.dataset.index)];
      if(!m.open||!artReady)return;
      card.querySelectorAll('[data-art-choice]').forEach(function(c){
        var key=c.dataset.artChoice,value=Number(c.dataset.artValue),sample=Object.assign({},m);
        sample[key]=value;
        var signature=JSON.stringify(sample);
        if(c.dataset.signature===signature)return;
        var ctx=c.getContext('2d');ctx.clearRect(0,0,c.width,c.height);ctx.drawImage(drawMember(sample),0,0,c.width,c.height);c.dataset.signature=signature;
      });
      card.querySelectorAll('[data-pet-variant]').forEach(function(c){var sample=Object.assign({},m,{animalColor:Number(c.dataset.petVariant)}),ctx=c.getContext('2d');ctx.clearRect(0,0,c.width,c.height);ctx.drawImage(drawMember(sample),0,0,c.width,c.height);});
      var avatar=card.querySelector('.pfp-mini-avatar');if(avatar){avatar.replaceChildren();var art=drawMember(m);art.style.cssText='width:100%;height:100%;object-fit:contain';avatar.appendChild(art);}
    });
  }
  function syncVariant(){
    var select=$('.pfp-variant-select');
    var variant=variants.find(function(v){return v.options.some(function(o){return o.toLowerCase()===state.mat.toLowerCase();});});
    if(variant)select.value=String(variant.id);
    var available=!!variant&&variant.available;
    $('[data-design-status]').textContent=!artReady?messages.loading:available?messages.ready:messages.soldout;
    $('.pfp-cart-button').disabled=!artReady||!available;
    root.querySelectorAll('[data-mat-choice],[data-count],[data-choice]').forEach(function(btn){btn.setAttribute('aria-pressed',btn.classList.contains('active')?'true':'false');});
  }
  function syncProperties(){
    var holder=$('[data-member-properties]');holder.replaceChildren();
    function add(name,value){var input=document.createElement('input');input.type='hidden';input.name='properties['+name+']';input.value=value;holder.appendChild(input);}
    add('Anzahl der Mitglieder',String(state.count));
    state.members.slice(0,state.count).forEach(function(m,i){
      var label=typeNames[m.type]+' · '+m.name;
      if(isHuman(m.type))label+=' | '+skinNames[m.skin]+' | Augen '+eyeNames[m.eyes]+' | '+hairstyles(m)[m.hairStyle]+' '+hairColors[m.hairColor]+' | Kleidung '+clothesNames[m.clothes]+' | '+glassesNames[m.glasses]+(m.type==='man'?' | '+beardNames[m.beard]:'');
      else label+=' | '+petDescription(m);
      add('Mitglied '+(i+1),label);
      var data=Object.assign({},m);delete data.open;delete data.name;
      add('_Mitglied '+(i+1),JSON.stringify(data));
    });
  }
  function buildDesign(){
    var c=document.createElement('canvas');c.width=1600;c.height=1000;var ctx=c.getContext('2d');
    MatFinishV10.background(ctx,state.mat);MatFinishV10.family(ctx,state.family.trim(),state.mat);
    var members=state.members.slice(0,state.count),arts=members.map(drawMember),positions=familyPositions(arts,1536,625);
    arts.forEach(function(art,i){
      var pos=positions[i],w=pos.width,h=w*1.25,x=32+pos.center-w/2;ctx.drawImage(art,x,1000-h,w,h);
      MatFinishV10.text(ctx,members[i].name,32+pos.center,1000-h+art.pfpTop/320*h-24,32,'bold3d',state.mat,-3,w*.95);
    });
    return c;
  }

  function renderCharacter(m){
    var character=document.createElement('div');
    character.className='pfp-character';
    character.dataset.type=m.type;
    var canvas=drawMember(m);
    canvas.className='pfp-character-art';
    canvas.setAttribute('role','img');
    canvas.setAttribute('aria-label',typeNames[m.type]+' '+m.name);
    character.appendChild(canvas);
    if(m.name){
      var name=document.createElement('div');
      name.className='pfp-character-name';
      name.textContent=m.name;
      character.appendChild(name);
    }
    return character;
  }

  function renderPreview(){
    var characters=$('[data-characters]');
    characters.innerHTML='';
    characters.dataset.count=String(state.count);
    $('[data-family-title]').textContent=state.family.trim()||'Unsere Familie';
    $('[data-mat]').classList.toggle('pfp-mat-gray',state.mat==='Grau');
    for(var i=0;i<state.count;i++)characters.appendChild(renderCharacter(state.members[i]));
    if(artReady){var preview=$('[data-mat-preview]');preview.getContext('2d').drawImage(buildDesign(),0,0);preview.setAttribute('aria-label',(state.family.trim()||'Unsere Familie')+' · '+state.members.slice(0,state.count).map(function(m){return m.name;}).join(', '));}
    updateThumbnails();
    syncVariant();
    syncProperties();
    $('[data-property-color]').value=state.mat;
    $('[data-property-family]').value=state.family.trim();
    $('[data-property-members]').value=state.members.slice(0,state.count).map(function(m,i){
      var value='Familienmitglied '+(i+1)+': '+typeNames[m.type]+', Name '+(m.name||'ohne Name');
      if(isHuman(m.type)){
        var hairstyle=hairstyles(m)[m.hairStyle];
        value+=' | Hautfarbe: '+skinNames[m.skin]+' | Augen: '+eyeNames[m.eyes]+' | Frisur: '+hairstyle+' | Haarfarbe: '+hairColors[m.hairColor]+' | Brille: '+glassesNames[m.glasses]+' | Kleidung: '+clothesNames[m.clothes];
        if(m.type==='man')value+=' | Bart: '+beardNames[m.beard];
      }else{
        value+=' | Rasse: '+petDescription(m);
      }
      return value;
    }).join(' || ');
  }
  var familyPositions=FamilyLayoutV9.positions;
  function positionNames(){
    var stage=$('[data-characters]'),stageBox=stage.getBoundingClientRect(),characters=Array.from(stage.children),arts=characters.map(function(c){return c.querySelector('canvas');});
    var positions=familyPositions(arts,stageBox.width,Math.max(1,stageBox.height-stageBox.width/1.536*.035));
    characters.forEach(function(character,i){var art=arts[i],label=character.querySelector('.pfp-character-name'),pos=positions[i];
      character.style.left=(pos.center-pos.width/2)+'px';character.style.width=pos.width+'px';character.style.height=pos.width*1.25+'px';
      if(label){label.style.bottom=((320-(art.pfpTop||0))*pos.width/256+stageBox.width/1.536*.012)+'px';label.style.fontSize=(stageBox.width/1.536*.03)+'px';}
    });
  }
  var nameObserver=new ResizeObserver(positionNames);nameObserver.observe(root);

  root.addEventListener('click',function(event){
    var matButton=event.target.closest('[data-mat-choice]');
    if(matButton&&root.contains(matButton)){
      state.mat=matButton.dataset.matChoice;
      root.querySelectorAll('[data-mat-choice]').forEach(function(b){b.classList.toggle('active',b===matButton);});
      renderPreview();return;
    }
    var countButton=event.target.closest('[data-count]');
    if(countButton&&root.contains(countButton)){
      state.count=Number(countButton.dataset.count);
      root.querySelectorAll('[data-count]').forEach(function(b){b.classList.toggle('active',b===countButton);});
      renderMembers();renderPreview();return;
    }
    var toggle=event.target.closest('.pfp-member-toggle');
    if(toggle&&root.contains(toggle)){
      var card=toggle.closest('.pfp-member');
      var ix=Number(card.dataset.index);
      state.members[ix].open=!state.members[ix].open;
      card.classList.toggle('open',state.members[ix].open);
      toggle.setAttribute('aria-expanded',state.members[ix].open?'true':'false');updateThumbnails();return;
    }
    var choice=event.target.closest('[data-choice]');
    if(choice&&root.contains(choice)){
      event.preventDefault();
      var memberCard=choice.closest('.pfp-member');
      var memberIndex=Number(memberCard.dataset.index);
      var key=choice.dataset.choice,value=Number(choice.dataset.value);
      if(key==='type'){
        state.members[memberIndex].type=typeKeys[value];
        state.members[memberIndex].animalBreed=Math.min(state.members[memberIndex].animalBreed,state.members[memberIndex].type==='cat'?12:16);
        state.members[memberIndex].hairStyle=Math.min(state.members[memberIndex].hairStyle,hairstyles(state.members[memberIndex]).length-1);
        state.members[memberIndex].open=true;
        state.members[memberIndex].animalColor=0;
        renderMembers(memberIndex);
      }else{
        state.members[memberIndex][key]=value;
        if(key==='animalBreed'){state.members[memberIndex].animalColor=0;renderMembers(memberIndex);}
        memberCard.querySelectorAll('[data-choice="'+key+'"]').forEach(function(btn){btn.classList.toggle('active',Number(btn.dataset.value)===value);});
      }
      renderPreview();return;
    }
  });

  root.addEventListener('input',function(event){
    if(event.target.matches('.pfp-member-name')){
      var card=event.target.closest('.pfp-member');
      state.members[Number(card.dataset.index)].name=event.target.value;
      var label=card.querySelector('.pfp-member-kicker');
      if(label)label.textContent='Familienmitglied '+(Number(card.dataset.index)+1)+' · '+typeNames[state.members[Number(card.dataset.index)].type];
      renderPreview();
    }
    if(event.target.matches('[data-family-input]')){
      state.family=event.target.value;renderPreview();
    }
  });

  var reviewRating=0;
  root.querySelectorAll('[data-rating]').forEach(function(button){
    button.addEventListener('click',function(){
      reviewRating=Number(this.dataset.rating);
      root.querySelectorAll('[data-rating]').forEach(function(star){
        star.classList.toggle('active',Number(star.dataset.rating)<=reviewRating);
      });
      $('[data-review-feedback]').textContent='';
    });
  });
  $('[data-review-submit]').addEventListener('click',function(){
    var reviewer=$('[data-review-name]').value.trim();
    var message=$('[data-review-text]').value.trim();
    var feedback=$('[data-review-feedback]');
    if(!reviewRating||!message){feedback.textContent='Bitte wähle Sterne und schreibe eine kurze Bewertung.';return;}
    var item=document.createElement('div');
    item.className='pfp-review-item';
    var stars=document.createElement('div');
    stars.className='pfp-review-item-stars';
    stars.textContent='★'.repeat(reviewRating)+'☆'.repeat(5-reviewRating);
    var author=document.createElement('strong');
    author.textContent=reviewer||'Kunde';
    var body=document.createElement('div');
    body.textContent=message;
    item.appendChild(stars);item.appendChild(author);item.appendChild(body);
    $('[data-review-list]').prepend(item);
    $('[data-review-text]').value='';
    feedback.textContent='Danke für deine Bewertung. Sie wird in dieser Vorschau angezeigt.';
  });

  var form=root.querySelector('form'),submitting=false,prepared=false;
  form.addEventListener('submit',async function(event){
    if(prepared)return;
    event.preventDefault();
    if(submitting||!artReady)return;
    syncVariant();if($('.pfp-cart-button').disabled)return;
    submitting=true;$('.pfp-cart-button').disabled=true;$('[data-design-status]').textContent=messages.saving;
    try{
      var blob=await new Promise(function(resolve){buildDesign().toBlob(resolve,'image/png');});
      if(!blob)throw new Error('Design export failed');
      var transfer=new DataTransfer();transfer.items.add(new File([blob],'familienmatte-v10.png',{type:'image/png'}));
      $('[data-design-file]').files=transfer.files;
      syncProperties();prepared=true;form.requestSubmit();
    }catch(error){submitting=false;prepared=false;$('[data-design-status]').textContent=messages.failed;$('.pfp-cart-button').disabled=false;}
  });
  var storageKey='family-builder-v8-'+config.v18;
  try{
    var saved=JSON.parse(sessionStorage.getItem(storageKey));
    if(saved&&Array.isArray(saved.members)&&saved.members.length===7){
      state.count=Math.max(1,Math.min(7,parseInt(saved.count,10)||1));state.mat=saved.mat==='Grau'?'Grau':'Beige';
      state.family=typeof saved.family==='string'?saved.family.slice(0,30):state.family;
      saved.members.forEach(function(m,i){
        if(!m||!typeKeys.includes(m.type))return;state.members[i].type=m.type;
        state.members[i].name=typeof m.name==='string'?m.name.slice(0,24):state.members[i].name;
        ['skin','eyes','hairStyle','hairColor','beard','glasses','clothes','animalBreed','animalColor','animalEyes'].forEach(function(k){var max={skin:5,eyes:5,animalEyes:5,animalBreed:m.type==='cat'?12:16,hairStyle:m.type==='man'?8:7,animalColor:15}[k]??7;state.members[i][k]=Math.max(0,Math.min(max,parseInt(m[k],10)||0));});
        state.members[i].animalColor=Math.min(state.members[i].animalColor,(petVariants(state.members[i]).length||1)-1);
      });
    }else{
      var selected=variants.find(function(v){return String(v.id)===$('.pfp-variant-select').value;});
      if(selected)state.mat=selected.options.includes('Grau')?'Grau':'Beige';
    }
  }catch(error){}
  var save=function(){try{sessionStorage.setItem(storageKey,JSON.stringify(state));}catch(error){}};
  root.addEventListener('input',save);root.addEventListener('click',save);
  $('[data-family-input]').value=state.family;
  root.querySelectorAll('[data-mat-choice]').forEach(function(b){b.classList.toggle('active',b.dataset.matChoice===state.mat);});
  root.querySelectorAll('[data-count]').forEach(function(b){b.classList.toggle('active',Number(b.dataset.count)===state.count);});
  renderMembers();
  Promise.all([document.fonts.load('80px MatScript')].concat(Object.keys(atlasUrls).map(function(key){return new Promise(function(resolve,reject){var image=new Image();image.crossOrigin='anonymous';image.onload=function(){atlasImages[key]=image;resolve();};image.onerror=reject;image.src=atlasUrls[key];});}))).then(function(){artRenderer=FamilyArtV9.create(atlasImages);artReady=true;renderMembers();renderPreview();}).catch(function(){$('[data-design-status]').textContent=messages.failed;});

}
function initFamilyBuilders(){document.querySelectorAll('[data-family-config]').forEach(function(el){try{initFamilyBuilder(JSON.parse(el.textContent));}catch(error){console.error('Family builder initialization failed',error);}});}
initFamilyBuilders();
if(!document.documentElement.dataset.familyBuilderListener){document.documentElement.dataset.familyBuilderListener='1';document.addEventListener('shopify:section:load',initFamilyBuilders);}



